import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'

import SearchPanel from "./SelectItemDialog/SearchPanel"

import TreeList from "./SelectItemDialog/TreeList"
import ItemIcon from '@material-ui/icons/BeachAccess'
import CategorysPanel from "./SelectItemDialog/CategorysPanel"
import ShopFilterPanel from './SelectItemDialog/ShopFilterPanel'

import SelectShopDialog from "./../shop/SelectShopDialog.js"

import ErrorMessageDialog from "./../ui/ErrorMessageDialog"

import Cookie from "../Cookie"
import {config} from "../config"

import api from '../api.js'

/**
 * onSelectItem(item)
 * onCancel()
 */

class SelectItemDialog extends Component {

	state = {
		items: [],
		selected: undefined,
		filters: [],
		dialog: undefined,
		filter_shops: [],
	}

	constructor(props) {
		super(props)
		this.handleAttchCategory = this.handleAttchCategory.bind(this)
		this.handleDetachCategory = this.handleDetachCategory.bind(this)
		this.handleSerchChange = this.handleSerchChange.bind(this)
		this.handleClickItem = this.handleClickItem.bind(this)
		this.handleSelectButtonClick = this.handleSelectButtonClick.bind(this)
		this.handleCancelButtonClick = this.handleCancelButtonClick.bind(this)
		this.handle_error = this.handle_error.bind(this)
	}

	async getItems() {
		let filter = "&filter=" + this.state.filters.map(item => item.id).join(",")
		let search = this.state.searchString ? `&search=${encodeURIComponent(this.state.searchString)}` : ""
		let response = await fetch(`${config.restApiHost}/inventory/items?sid=${Cookie.get("sid")}${filter}${search}`, { method: "GET" })
		let json = await response.json()
		if (response.status === 200) {
			return json
		} else {
			throw new Error(json.message)
		}		
	}

	// getItems() {
	// 	return new Promise((resolve, reject) => {
	// 		let filter = "&filter=" + this.state.filters.map(item => item.id).join(",")
	// 		let search = this.state.searchString ? `&search=${encodeURIComponent(this.state.searchString)}` : ""
	// 		let xhr = new XMLHttpRequest()
	// 		xhr.open("GET", config.restApiHost + `/inventory/items?sid=${Cookie.get("sid")}${filter}${search}`, true)
	// 		xhr.onreadystatechange = ()=>{
	// 			if (xhr.readyState === 4) {
	// 				if (xhr.status === 200) {
	// 					resolve(JSON.parse(xhr.responseText))
	// 				} else {
	// 					reject("Не удалось получить список предметов")
	// 				}
	// 			}
	// 		}
	// 		xhr.send()
	// 	})
	// }

	async update() {
		// let items = await this.getItems()
		let items = await api.inventory.list(
			this.state.search,
			this.state.filters,
			this.state.filter_shops,
		) 
		this.setState({items: items})
	}

	componentDidMount() {
		this.update().catch(this.handle_error)
	}

	// handle_error(errorMessage) {
	// 	this.setState({
	// 		dialog: <ErrorMessageDialog
	// 			message = {errorMessage}
	// 			onClose = {this.props.onCancel}
	// 		/>
	// 	})
	// }

	handle_error(error) {
        let message = error instanceof String ? error : error.message
		this.setState({
			dialog: <ErrorMessageDialog 
				message = {message}
				onClose = {() => {
					this.update()
						.then(() => {this.setState({dialog: undefined})})
						.catch(this.handle_error)
				}}
			/>
		})
	}		

	handleAttchCategory(category) {
		this.state.filters.push(category)
		this.update()
	}

	handleDetachCategory(category) {
		this.setState({
			filters: this.state.filters.filter(f => f.id !== category.id)
		}, this.update)
	}

	handleSerchChange(searchString) {
		this.setState({
			searchString: searchString
		}, this.update)
	}

	handleClickItem(item) {
		if (this.state.selected ? this.state.selected.id === item.id : false) {
			if (this.state.selected.type === "0") {
				item.expand = !item.expand
				this.forceUpdate()
			} else {
				if (typeof this.props.onSelectItem === "function") {
					this.props.onSelectItem(item)
				}
			}
		} else {
			this.setState({
				selected: item
			})
		}
	}

	handleSelectButtonClick(e) {
		e.stopPropagation()
		if (typeof this.props.onSelectItem === "function") {
			this.props.onSelectItem(this.state.selected)
		}
	}

	handleCancelButtonClick(e) {
		e.stopPropagation()
		if (typeof this.props.onCancel === "function") {
			this.props.onCancel()
		}
	}

	render() {

		if (this.state.dialog) {
			return this.state.dialog
		}

		if (!this.state.items) {
			return null
		}

		return <Dialog
			open = {true}
			scroll = "body"
		>

			<DialogTitle>
				Выбрать предмет
			</DialogTitle>

			<DialogContent>

				<ShopFilterPanel 
					chips = {this.state.filter_shops}
					onAddShopButtonClick = {() => {
						this.setState({dialog: <SelectShopDialog 
							hideNoShop
							hideShops = {this.state.filter_shops}
							onSelectClick = {async (shop) => {
								try {
									this.state.filter_shops.push(shop)
									this.setState({
										filter_shops: this.state.filter_shops,
										dialog: undefined,
									})
									await this.update()
								}
								catch (error) {
									await this.handle_error(error)
								}
							}}
							onCancelClick = {() => {this.setState({ dialog: undefined })}}
						/>})
					}}
					onShopFilterChipDeleteClick = {async (chip) => {
						this.setState({ filter_shops: this.state.filter_shops.filter((shop => shop.id !== chip.id)) }, await this.update)
					}}
				/>

				{/* <CategorysPanel
					title = "Фильтры"
					parent = {this}
					categorys = {this.state.filters}
					onAttachCategory = {this.handleAttchCategory}
					onDetachCategory = {this.handleDetachCategory}
				/> */}

				<SearchPanel
					onChange = {this.handleSerchChange}
				/>

				<TreeList
					items = {this.state.items}
					selected = {this.state.selected}
					itemIcon = {<ItemIcon />}
					onClickItem = {this.handleClickItem}
				/>

			</DialogContent>

			<DialogActions>
				<Button onClick = {this.handleSelectButtonClick} disabled = {!this.state.selected}>Выбрать</Button>
				<Button onClick = {this.handleCancelButtonClick}>Отмена</Button>
			</DialogActions>

		</Dialog>

	}

}

export default SelectItemDialog
